import UserPage from './components/UserPage'

export default UserPage
